'use es6';

import { createSelector } from 'reselect';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import { getMinimumRequiredPlan } from '../utils/compatibility';
import { getIsUngatedForContentHub } from './auth';
export const getFeatureCompatibility = state => state.details.get('compatibility');
export const makeGetRequiredPlansForFeatures = () => createSelector([getFeatureCompatibility, (_, integrationFeatures) => integrationFeatures, getIsUngatedForContentHub], ({
  compatibility,
  portalTiers
}, integrationFeatures, isUngatedForContentHub) => {
  if (!compatibility || compatibility.isEmpty() || !integrationFeatures) {
    return null;
  }
  return integrationFeatures.map(integrationFeature => getMinimumRequiredPlan(integrationFeature, compatibility, portalTiers, isUngatedForContentHub));
});
const getSlugFromProps = (_, props) => props.slug;
const getListingViewsCache = state => state.details.get('listingViewsCache');
const getListingViewsFetchErrorCache = state => state.details.get('listingViewsFetchErrorCache');
const getListingViewsFetchStatusCache = state => state.details.get('listingViewsFetchStatusCache');
export const makeGetListingViewFetchError = () => createSelector([getSlugFromProps, getListingViewsFetchErrorCache], (slug, listingViewsFetchErrorCache) => listingViewsFetchErrorCache.get(slug));
export const makeGetListingViewFetchStatus = () => createSelector([getSlugFromProps, getListingViewsFetchStatusCache], (slug, listingViewsFetchStatusCache) => listingViewsFetchStatusCache.get(slug, RequestState.UNINITIALIZED));
export const makeGetListingView = () => createSelector([getSlugFromProps, getListingViewsCache], (slug, listingViewsCache) => listingViewsCache.get(slug));
export const getListingViewReferrer = state => state.details.get('referrer');